var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navbar" }, [
    _c(
      "div",
      { staticClass: "right-menu spaceLeft" },
      [
        _c("div", { staticClass: "right-menu_account" }, [
          _vm._v(
            "Account: " + _vm._s(_vm.userInfo.username || _vm.getUserName())
          ),
        ]),
        _vm._v(" "),
        _c("svg-icon", {
          staticClass: "right-menu_svg",
          attrs: { "icon-class": "tn-logout" },
          on: { click: _vm.logout },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }